import React from "react";
import "./footer.css";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* 1. Logo Section */}
        <div className="footer-section">
          <h2 className="footer-logo">Muhurtmedh</h2>
          <p>Making your wedding moments memorable and elegant.</p>
        </div>

        {/* 2. Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#hero">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#features">Features</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* 3. Contact Details */}
        <div className="footer-section">
          <h3>Contact</h3>
          <p>📍 Sangli, Maharashtra</p>
          <p>📞 +91 98765 43210</p>
          <p>✉️ info@muhurtmedh.com</p>
        </div>

        {/* 4. Social Media Icons */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="footer-socials">
            <a href="#"><FaFacebook /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Muhurtmedh. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
